import UserMedalDailog from './src/main';

/* istanbul ignore next */
UserMedalDailog.install = function(Vue) {
  Vue.component(UserMedalDailog.name, UserMedalDailog);
};

export default UserMedalDailog;
